export const LOGIN = "/login";
export const PROFILE = "/profile";
export const MN_APPLICATION = "/mn/apps";
export const MN_USER = "/mn/users";
export const MN_USER_NEW = "/mn/users/new";
export const MN_REQUEST = "/mn/requests";
export const MN_RESPONSE = "/mn/responses";
export const MN_ID_SEARCH = "/mn/search/ids";
export const MN_SAILOR_SEARCH = "/mn/search/sailors";
export const MN_SHIP_SEARCH = "/mn/search/ship";
export const MN_ID_RESPONSE = "/mn/responses/ids";
export const MN_SAILOR_RESPONSE = "/mn/responses/sailors";
export const MN_VIOLATION_RESPONSE = "/mn/responses/violation";
export const MN_DEVICE = "/mn/devices";
